import { useState } from 'react';
import axios from 'axios';
import Loader from './helpers/Loader';

const DISCOVER_PANEL_URL = 'https://sasovo.cdn-yandex.net/v2-api/vless/discoverPanel';
const CREATE_SERVER_URL = 'https://sasovo.cdn-yandex.net/v2-api/vless/createServerFromPanel';

const defaultsFor = (id) => ({
	'1': '443, tls, h3, firefox', '2': '443, tls, http/1.1, firefox',
	'3': '443, tls, h2, firefox', '4': '8443, tls, h2, edge',
}[String(id)] || '443, tls, h3, firefox');

export default function ServerCreationOverlayVless({ close, getList }) {
	const [panelUrl, setPanelUrl] = useState('');
	const [apiKey, setApiKey] = useState('');
	const [publicDomain, setPublicDomain] = useState('');
	const [plan, setPlan] = useState(0);
	const [subscriptionUrl, setSubscriptionUrl] = useState('');
	const [inbounds, setInbounds] = useState([]);
	const [selectedIds, setSelectedIds] = useState([]);
	const [showLegacy, setShowLegacy] = useState(false);
	const [login, setLogin] = useState('');
	const [password, setPassword] = useState('');
	const [isLoading, setLoading] = useState(false);
	const [error, setError] = useState('');

	const headers = () => {
		const token = localStorage.getItem('simple_vpn_token');
		if (!token) throw new Error('Токен не найден');
		return { Authorization: `Bearer ${token}` };
	};
	const panel = () => ({ panelUrl, publicDomain, apiKey, legacyCredentials: { login, password } });
	const toggle = (id) => setSelectedIds((ids) => ids.includes(id) ? ids.filter((value) => value !== id) : [...ids, id]);

	const loadInbounds = async () => {
		if (!panelUrl.trim()) return setError('Укажите полный адрес панели с портом.');
		if (!publicDomain.trim()) return setError('Укажите публичный домен сервера.');
		if (!apiKey.trim() && !(login.trim() && password.trim())) return setError('Укажите API-ключ или доступы старой панели.');
		setLoading(true); setError('');
		try {
			const { data } = await axios.post(DISCOVER_PANEL_URL, panel(), { headers: headers() });
			if (!data.ok || !data.inbounds?.length) throw new Error(data.message || 'Панель не вернула доступных инбондов.');
			setInbounds(data.inbounds); setSelectedIds([]); setSubscriptionUrl(data.subscriptionUrl || '');
		} catch (requestError) {
			setInbounds([]); setSelectedIds([]);
			setError(requestError.response?.data?.message || requestError.message || 'Не удалось загрузить инбонды.');
		} finally { setLoading(false); }
	};

	const save = async () => {
		if (!selectedIds.length) return setError('Выберите хотя бы один инбонд.');
		if (!publicDomain.trim() || !subscriptionUrl.trim()) return setError('Укажите публичный домен и URL подписки.');
		setLoading(true); setError('');
		try {
			const { data } = await axios.post(CREATE_SERVER_URL, { ...panel(), publicDomain, subscriptionUrl, plan, selectedInboundIds: selectedIds }, { headers: headers() });
			if (!data.ok) throw new Error(data.message || 'Не удалось сохранить сервер.');
			getList(); close();
		} catch (requestError) { setError(requestError.response?.data?.message || requestError.message || 'Не удалось сохранить сервер.'); }
		finally { setLoading(false); }
	};

	return <div className='overlay' id='overlay' onClick={(event) => event.target.id === 'overlay' && close()}>
		<div className='overlay-content overlay-content-server wrapped'>
			<div>Добавить сервер</div>
			<input className='t-input' placeholder='Полный адрес панели с портом' value={panelUrl} onChange={(event) => setPanelUrl(event.target.value.trim())} />
			<input className='t-input' placeholder='API-ключ' value={apiKey} onChange={(event) => setApiKey(event.target.value.trim())} />
			<input className='t-input' placeholder='Публичный домен сервера' value={publicDomain} onChange={(event) => setPublicDomain(event.target.value.trim())} />
			<select className='t-input' value={plan} onChange={(event) => setPlan(event.target.value)}><option value={0}>Base</option><option value={1}>Premium</option><option value={2}>Deeplink</option><option value={3}>Family</option><option value={15}>Family 1y</option><option value={4}>1 Month / UK 🇬🇧</option><option value={5}>1 Month / Finland 🇫🇮</option><option value={6}>1 Month / Germany 🇩🇪</option><option value={10}>1 Month / USA 🇺🇸</option><option value={12}>1 Month / Rus 🇷🇺</option><option value={8}>6 Month / 🇬🇧 UK</option><option value={9}>6 Month / 🇫🇮 Finland</option><option value={13}>6 Month / 🇩🇪 Germany</option><option value={14}>6 Month / 🇺🇸 USA</option><option value={20}>1 Month / Я в Китае 🇨🇳</option><option value={21}>6 Month / Я в Китае 🇨🇳</option><option value={30}>Бизнес</option><option value={99}>Trial (.99)</option></select>
			<button className='t-button' onClick={() => setShowLegacy(!showLegacy)}>Дополнительные настройки старой панели</button>
			{showLegacy && <><input className='t-input' placeholder='Логин' value={login} onChange={(event) => setLogin(event.target.value)} /><input className='t-input' type='password' placeholder='Пароль' value={password} onChange={(event) => setPassword(event.target.value)} /></>}
			<button onClick={loadInbounds} className='t-button'>{isLoading ? <Loader /> : 'Загрузить инбонды'}</button>
			{inbounds.length > 0 && <><input className='t-input' placeholder='URL подписки' value={subscriptionUrl} onChange={(event) => setSubscriptionUrl(event.target.value)} /><div className='server-label'><span>Выберите инбонды</span></div>{inbounds.map((inbound) => <label className='server-label' key={inbound.id}><input type='checkbox' checked={selectedIds.includes(inbound.id)} onChange={() => toggle(inbound.id)} /> <span>ID {inbound.id} · Config Port {inbound.configPort} · {inbound.label || 'Inbound'}<br />Подмена: {publicDomain || 'публичный домен'} · {defaultsFor(inbound.id)}</span></label>)}<button onClick={save} className='t-button t-primary'>{isLoading ? <Loader /> : 'Сохранить сервер и выбранные инбонды'}</button></>}
			{error && <div className='server-label'>{error}</div>}
		</div>
	</div>;
}
